import orderBy from 'lodash.orderby';
import {
  isArrayEmpty,
  isDefined,
  doesArrayHasLength
} from '../../../utils/isDefined';
import Optional from '../../../utils/optional';

const OFFICE_MOBILE = 'OFFICE_MOBILE';
const PRIVATE_MOBILE = 'PRIVATE_MOBILE';
const EMPTY_OPTION = { label: '', value: '' };

export default function mapCellNumbers(user) {
  const { sim_cards = [], mitelData = {} } = user;
  const defaultDomainNumber = Optional(mitelData.phone_numbers)
    .map(numbers =>
      Optional(numbers.find(number => number.number_type === OFFICE_MOBILE)).or(
        numbers.find(number => number.number_type === PRIVATE_MOBILE)
      )
    )
    .or(void 0);

  let numbers = [],
    defaultNumbers = [];

  const simCards = sim_cards.map(simcard => {
    let foundedNumber = null;
    if (isDefined(simcard?.msisdn)) {
      const datalimitId = findDatalimitId(simcard?.cell_numbers);

      if (isDefined(defaultDomainNumber)) {
        foundedNumber =
          defaultDomainNumber.value.replace(/\+/g, '') === simcard.msisdn;

        if (foundedNumber) {
          defaultNumbers = [
            ...defaultNumbers,
            {
              value: simcard.msisdn,
              label: simcard.msisdn,
              datalimitId,
              card_type: simcard.card_type,
              primary_card_id: simcard.primary_card_id,
              id: simcard.id
            }
          ];
        } else {
          numbers = [
            ...numbers,
            {
              value: simcard.msisdn,
              label: simcard.msisdn,
              datalimitId,
              card_type: simcard.card_type,
              primary_card_id: simcard.primary_card_id,
              id: simcard.id
            }
          ];
        }
      } else {
        numbers = [
          ...numbers,
          {
            value: simcard.msisdn,
            label: simcard.msisdn,
            datalimitId,
            card_type: simcard.card_type,
            primary_card_id: simcard.primary_card_id,
            id: simcard.id
          }
        ];
      }
    }

    return { ...simcard };
  });

  const sortedNumbers = createSelectOptions({ defaultNumbers, numbers });

  return {
    sim_cards: simCards,
    selectOptions: {
      numbers: sortedNumbers
    },
    selectedNumber: Optional(sortedNumbers[0]).or(EMPTY_OPTION)
  };
}

const findDatalimitId = cellNumbers => {
  if (!doesArrayHasLength(cellNumbers)) {
    return void 0;
  }

  return Optional(cellNumbers[0].data_limit?.id).or(void 0);
};

const createSelectOptions = ({ defaultNumbers, numbers }) => {
  if (isArrayEmpty(numbers) && isArrayEmpty(defaultNumbers)) {
    return [];
  }

  const allNumbers = [
    ...orderBy(defaultNumbers, 'label'),
    ...orderBy(numbers, 'label')
  ];

  const filteredNumbers = allNumbers.filter(
    number => number.card_type !== 'data_sharing_card'
  );

  return filteredNumbers.map(number => {
    const extraNumbers = allNumbers
      .filter(item => item.primary_card_id === Number(number.id))
      .map(item => item.value);

    return {
      ...number,
      extraNumbers:
        extraNumbers.length > 0 ? `${extraNumbers.join(' ,')}` : null
    };
  });
};
